import React, { useState } from 'react';

import SatInput from '@components/common/satUI/SatInput';
import { toCurrency } from '@common/utils/index';
import SatToolTip from '@components/common/satUI/SatToolTip';

const GaCommission = props => {
  const { totalBC, collectBC, serviceBC, currencyUsdYN, calculateDate } = props;

  const [toggle, setToggle] = useState(false);
  const [isShowTooltip, setIsShowTooltip] = useState(false);

  return (
    <React.Fragment>
      <SatToolTip
        show={isShowTooltip}
        setShow={flag => setIsShowTooltip(flag)}
        position={'top right'}
        toolTips={[
          {
            title: '환산보험료',
            message: () => <p>보험료계산 후 확인 가능합니다.</p>,
          },
        ]}
        divStyle={{ float: 'right' }}
      />
      <div className="amount-group">
        <button
          type="button"
          className={`btn-toggle2 ${toggle ? 'close' : 'open'}`}
          onClick={() => setToggle(!toggle)}
        ></button>
        <ul>
          <li>
            <SatInput
              value={toCurrency(totalBC, currencyUsdYN === 'Y' ? 2 : 0)}
              label={calculateDate > '20220101' ? '초년도' : 'BC'}
              readOnly
              textAlign={'text-right'}
              suffix={() => (
                <span className="txt-amount">
                  {currencyUsdYN === 'Y' ? '달러' : '원'}
                </span>
              )}
            />
          </li>
          <li>
            <SatInput
              value={toCurrency(collectBC, currencyUsdYN === 'Y' ? 2 : 0)}
              label={calculateDate > '20220101' ? '2차년도' : '계약모집BC'}
              readOnly
              textAlign={'text-right'}
              suffix={() => (
                <span className="txt-amount">
                  {currencyUsdYN === 'Y' ? '달러' : '원'}
                </span>
              )}
            />
          </li>
          <li>
            <SatInput
              value={toCurrency(serviceBC, currencyUsdYN === 'Y' ? 2 : 0)}
              label={calculateDate > '20220101' ? '3차년도' : '계약유지BC'}
              readOnly
              textAlign={'text-right'}
              suffix={() => (
                <span className="txt-amount">
                  {currencyUsdYN === 'Y' ? '달러' : '원'}
                </span>
              )}
            />
          </li>
        </ul>
      </div>
    </React.Fragment>
  );
};

export default React.memo(GaCommission);
